import { useState, useEffect, useContext, useRef, useMemo } from "react";
import type { SnapshotDataTypes } from "pages/service";
import { SvgLogo } from "ui/svgs";
import { Checkbox } from "antd";
import clsx from "clsx";

export default function CameraCreateItem({
  objCamera,
  snapshot,
  index,
  onCameraNameChanged,
  checked,
  onChecked,
}: {
  objCamera: any;
  snapshot: SnapshotDataTypes;
  index: number;
  onCameraNameChanged: (a: number, b: string) => void;
  checked: boolean;
  onChecked: (checked: boolean) => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [cameraName, setCameraName] = useState(objCamera.name);

  const prerequisiteErr = objCamera?.devicePrerequisite?.prerequisiteList?.find(
    (e) => e.level === "error",
  );

  const prerequisiteWarn =
    objCamera?.devicePrerequisite?.prerequisiteList?.find(
      (e) => e.level === "warn",
    );

  const prerequisiteContent =
    prerequisiteErr?.msg || prerequisiteWarn?.msg || "";

  useEffect(() => {
    onCameraNameChanged(index, cameraName);
  }, [cameraName]);

  const snapshotSrc = useMemo(() => {
    if (snapshot?.blob) {
      return URL.createObjectURL(snapshot?.blob);
    }
    return null;
  }, [snapshot]);

  return (
    <div
      className={clsx(
        "rounded-lg bg-gray-100 focus:outline-none overflow-hidden relative border-2",
        prerequisiteErr
          ? " border-red-500"
          : prerequisiteWarn
            ? "border-[#FF9800]"
            : "border-transparent",
      )}
      tabIndex={index}
      ref={ref}
    >
      {!prerequisiteErr && (
        <Checkbox
          className="absolute top-3 left-3"
          checked={checked}
          onChange={(e) => {
            onChecked(e.target.checked);
          }}
        />
      )}

      <div className="relative w-full aspect-video">
        {snapshotSrc ? (
          <img
            src={snapshotSrc}
            alt="Camera Placeholder"
            className="aspect-video"
          />
        ) : (
          <div className="w-full aspect-video flex items-center justify-center">
            <SvgLogo width="28" className="fill-zinc-400" />
          </div>
        )}
        {prerequisiteContent && (
          <div
            className={clsx(
              "absolute w-full h-full flex items-center justify-center top-0 left-0 px-4",
              prerequisiteErr
                ? "bg-[#F73D2F] bg-opacity-80"
                : "bg-[#FF9800] bg-opacity-80",
            )}
          >
            <p className="font-semibold text-white text-sm text-center">
              {prerequisiteContent}
            </p>
          </div>
        )}
      </div>
      <div className="p-2 text-sm text-center min-h-9 ">
        <input
          className="px-3 w-full bg-white rounded-lg overflow-hidden break-words text-nowrap text-ellipsis hover:bg-blue-100 text-center focus:border-blue-500 caret-blue-500 focus-visible:border-blue-500 focus-visible:outline-none border disabled:hover:bg-white"
          value={cameraName}
          disabled={!checked}
          onChange={(e) => {
            if (e.target.value?.length > 50) {
              setCameraName(e.target.value.slice(0, 50));
            } else {
              setCameraName(e.target.value);
            }
          }}
        ></input>
      </div>
    </div>
  );
}
